import GamecenterEntriesOverallPage from '~/domains/contest/domains/gamecenter/pages/entries/overall';

function EntriesOverallPage() {
  return <GamecenterEntriesOverallPage />;
}

EntriesOverallPage.hasOwnAppshell = true;

export default EntriesOverallPage;
